export default __webpack_public_path__ + "static/media/feedback.7c713ad0.png";